import { isProductionBuild, requireEnvChainId, requireEnvString, SEPOLIA_CHAIN_ID } from "../../config/publicEnv";

export { SEPOLIA_CHAIN_ID };

export const OSHAR_COLLECTION_NAME = "Oshar Genesis Real Estate";

/** @dev Sepolia test default — never used when NODE_ENV=production */
const DEV_OSHAR_CONTRACT_ADDRESS = "0xec12b04d993350b2046c6d8fc205E71d0571F703";
const DEV_SEPOLIA_USDC_ADDRESS = "0x1c7D4B196Cb0C7B01d743Fbc6116a902379C7238";

export const OSHAR_REAL_ESTATE_CHAIN_ID = requireEnvChainId(
  "REACT_APP_OSHAR_REAL_ESTATE_CHAIN_ID",
  SEPOLIA_CHAIN_ID
);

/**
 * Primary: REACT_APP_OSHAR_REAL_ESTATE_CONTRACT_ADDRESS.
 * Dev fallback: REACT_APP_OSHAR_SEPOLIA_CONTRACT_ADDRESS, then baked Sepolia test address.
 */
export const OSHAR_REAL_ESTATE_CONTRACT_ADDRESS = (() => {
  const primary = String(process.env.REACT_APP_OSHAR_REAL_ESTATE_CONTRACT_ADDRESS ?? "").trim();
  if (primary) {
    return requireEnvString("REACT_APP_OSHAR_REAL_ESTATE_CONTRACT_ADDRESS", primary);
  }
  return requireEnvString(
    "REACT_APP_OSHAR_SEPOLIA_CONTRACT_ADDRESS",
    DEV_OSHAR_CONTRACT_ADDRESS
  );
})();

/** @deprecated Use OSHAR_REAL_ESTATE_CONTRACT_ADDRESS */
export const OSHAR_SEPOLIA_CONTRACT_ADDRESS = OSHAR_REAL_ESTATE_CONTRACT_ADDRESS;

export const SEPOLIA_USDC_ADDRESS = requireEnvString(
  "REACT_APP_SEPOLIA_USDC_ADDRESS",
  DEV_SEPOLIA_USDC_ADDRESS
);

const DEFAULT_SEPOLIA_RPC_URL = "https://ethereum-sepolia-rpc.publicnode.com";
const DEFAULT_MAINNET_RPC_URL = "https://eth.llamarpc.com";

/** Read-only JSON-RPC for Oshar contract reads (env-driven chain). */
export function getOsharRealEstateRpcUrl() {
  const dedicated = String(process.env.REACT_APP_OSHAR_REAL_ESTATE_RPC_URL ?? "").trim();
  if (dedicated) return dedicated;
  if (Number(OSHAR_REAL_ESTATE_CHAIN_ID) === 1) {
    const mainnet = String(process.env.REACT_APP_MAINNET_RPC_URL ?? "").trim();
    return mainnet || DEFAULT_MAINNET_RPC_URL;
  }
  const sepolia = String(process.env.REACT_APP_SEPOLIA_RPC_URL ?? "").trim();
  if (sepolia) return sepolia;
  if (isProductionBuild()) {
    throw new Error(
      "Missing REACT_APP_OSHAR_REAL_ESTATE_RPC_URL for production builds. See .env.example."
    );
  }
  return DEFAULT_SEPOLIA_RPC_URL;
}

export const OSHAR_REAL_ESTATE_ABI = [
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenEthPrice",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenUsdcPrice",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "ownerOf",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "tokenURI",
    outputs: [{ internalType: "string", name: "", type: "string" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "mintWithETH",
    outputs: [{ internalType: "uint256", name: "mintedTokenId", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [{ internalType: "uint256", name: "tokenId", type: "uint256" }],
    name: "mintWithUSDC",
    outputs: [{ internalType: "uint256", name: "mintedTokenId", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "authorizedSigner",
    outputs: [{ internalType: "address", name: "", type: "address" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "address", name: "signer", type: "address" }],
    name: "setAuthorizedSigner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];
